import script from "./CommentsDrawMember.vue?vue&type=script&setup=true&lang=js"
export * from "./CommentsDrawMember.vue?vue&type=script&setup=true&lang=js"

import "./CommentsDrawMember.vue?vue&type=style&index=0&id=40c9c75e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40c9c75e"]])

export default __exports__